module.exports = __webpack_public_path__ + "static/img/left_logo_icon.bdc5b9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/left_logo_icon.png
// module id = Z+fK
// module chunks = 52